import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  boardingPassDetails: [],
  bpAddGoogleWallet: "",
  bpAddAppleWallet: "",
  isLoading: false,
  error: "",
  googleError: "",
  appleError: "",
  bpSavePdf: "",
  bpSaveError: "",
  sendEmail: "",
  sendEmailError: "",
  standByPaxBoardingPass: []
};
const fetchCheckinBoardingPassSlice = createSlice({
  name: "checkinBoardingPass",
  initialState,
  reducers: {
    checkinBoardingPassDataRequest: state => {
      state.isLoading = true;
    },
    getCheckinBoardingPassSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.boardingPassDetails = action.payload.data;
    },
    getCheckinBoardingPassFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.boardingPassDetails = [];
    },
    googleWalletBpRequest: state => {
      state.isLoading = true;
    },
    googleWalletBpSuccess: (state, action) => {
      state.isLoading = false;
      state.googleError = "";
      state.bpAddGoogleWallet = action.payload.data;
    },
    googleWalletBpFailure: (state, action) => {
      state.isLoading = false;
      state.googleError = action.payload;
      state.bpAddGoogleWallet = [];
    },
    appleWalletBpRequest: state => {
      state.isLoading = true;
    },
    appleWalletBpSuccess: (state, action) => {
      state.isLoading = false;
      state.appleError = "";
      state.bpAddAppleWallet = action.payload.data;
    },
    appleWalletBpFailure: (state, action) => {
      state.isLoading = false;
      state.appleError = action.payload;
      state.bpAddAppleWallet = [];
    },
    savePdfRequest: state => {
      state.isLoading = true;
    },
    savePdfSuccess: (state, action) => {
      state.isLoading = false;
      state.bpSaveError = "";
      state.bpSavePdf = action.payload.data;
    },
    savePdfFailure: (state, action) => {
      state.isLoading = false;
      state.bpSaveError = action.payload;
      state.bpSavePdf = "";
    },
    sendEmailRequest: state => {
      state.isLoading = true;
    },
    sendEmailSuccess: (state, action) => {
      state.isLoading = false;
      state.sendEmailError = "";
      state.sendEmail = action.payload.data;
    },
    sendEmailFailure: (state, action) => {
      state.isLoading = false;
      state.sendEmailError = action.payload;
      state.sendEmail = [];
    },
    setStandByBoardingPassPax: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.standByPaxBoardingPass = action.payload;
    },
    clearBoardingPassData: state => {
      state.isLoading = false;
      state.bpAddGoogleWallet = "";
      state.bpAddAppleWallet = "";
      state.bpSavePdf = "";
      state.sendEmail = [];
      state.error = "";
      state.sendEmailError = "";
      state.bpSaveError = "";
      state.appleError = "";
      state.googleError = "";
      state.standByPaxBoardingPass = [];
    },
    resetBoardingPassData: state => {
      state.isLoading = false;
      state.boardingPassDetails = [];
      state.bpAddGoogleWallet = "";
      state.bpAddAppleWallet = "";
      state.bpSavePdf = "";
      state.sendEmail = [];
      state.error = "";
      state.sendEmailError = "";
      state.bpSaveError = "";
      state.appleError = "";
      state.googleError = "";
      state.standByPaxBoardingPass = [];
    }
  }
});
export const {
  checkinBoardingPassDataRequest,
  getCheckinBoardingPassSuccess,
  getCheckinBoardingPassFailure,
  googleWalletBpRequest,
  googleWalletBpSuccess,
  googleWalletBpFailure,
  appleWalletBpRequest,
  appleWalletBpSuccess,
  appleWalletBpFailure,
  savePdfRequest,
  savePdfSuccess,
  savePdfFailure,
  sendEmailRequest,
  sendEmailSuccess,
  sendEmailFailure,
  resetBoardingPassData,
  setStandByBoardingPassPax,
  clearBoardingPassData
} = fetchCheckinBoardingPassSlice.actions;
export default fetchCheckinBoardingPassSlice.reducer;